var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19465 3.40667L4.78754 6L2.19465 8.59333C2.13294 8.65506 2.08398 8.72833 2.05059 8.80897C2.01719 8.88961 2 8.97605 2 9.06333C2 9.15062 2.01719 9.23705 2.05059 9.3177C2.08398 9.39834 2.13294 9.47161 2.19465 9.53333C2.25636 9.59505 2.32962 9.64401 2.41025 9.67742C2.49088 9.71082 2.5773 9.72801 2.66457 9.72801C2.75184 9.72801 2.83826 9.71082 2.91889 9.67742C2.99952 9.64401 3.07278 9.59505 3.13449 9.53333L6.19397 6.47333C6.25577 6.41166 6.30479 6.3384 6.33824 6.25775C6.37169 6.1771 6.3889 6.09065 6.3889 6.00333C6.3889 5.91602 6.37169 5.82957 6.33824 5.74892C6.30479 5.66827 6.25577 5.59501 6.19397 5.53333L3.13449 2.46667C3.07282 2.40486 2.99958 2.35583 2.91894 2.32238C2.83831 2.28892 2.75187 2.2717 2.66457 2.2717C2.57727 2.2717 2.49083 2.28892 2.41019 2.32238C2.32956 2.35583 2.25631 2.40486 2.19465 2.46667C1.94136 2.72667 1.94136 3.15333 2.19465 3.40667ZM9.33345 2C9.70005 2 10 2.3 10 2.66667V9.33333C10 9.7 9.70005 10 9.33345 10C8.96684 10 8.66689 9.7 8.66689 9.33333V2.66667C8.66689 2.3 8.96684 2 9.33345 2Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLast);
export default __webpack_public_path__ + "static/media/last.e3e526e7df467a3261ded29cb5e4a854.svg";
export { ForwardRef as ReactComponent };